const updateCategoryMutation = `
  mutation UpdateMarketplaceCategory($id: ID!, $fields: UpdateMarketplace_categoryFieldsInput) {
    updateMarketplace_category(input: { id: $id, fields: $fields }) {
      marketplace_category {
        objectId
        name
        icon {
          name
          url
        }
        cover {
          name
          url
        }
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default updateCategoryMutation;
